import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next:not(.product-block-button-next)');
    const prev = section.querySelector('.swiper-button-prev:not(.product-block-button-prev)');

    if (carousel) {
      const swiper = new Swiper(carousel, {
        modules: [Navigation, Pagination],
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 8,
        watchOverflow: true,
        speed: 1000,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1440: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });
    }
  });
}
